import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

@Injectable({ providedIn: 'root' })
export class DeepLinkService {
  private readonly router = inject(Router);

  init(): void {
    if (!Capacitor.isNativePlatform()) return;

    App.addListener('appUrlOpen', ({ url }) => {
      const parsed = new URL(url);
      const isCustomScheme = parsed.protocol !== 'https:' && parsed.protocol !== 'http:';
      // custom scheme: bet.lumio.app://app/plans/success → host='app', path='/plans/success'
      // reconstruct as /host + path so it maps to Angular routes correctly
      const path = isCustomScheme
        ? '/' + parsed.host + parsed.pathname + parsed.search
        : parsed.pathname + parsed.search;
      this.router.navigateByUrl(path);
    });
  }
}
